import React from 'react';
import { UserProfile } from '../types';
import { AppSettings } from '../lib/storage';
import { PremiumView } from './PremiumView';
import { X } from 'lucide-react';

interface PremiumModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentUser: UserProfile;
  appSettings?: AppSettings;
  onUpdateProfile: (profile: Partial<UserProfile>) => void;
  onUpdateSettings?: (settings: Partial<AppSettings>) => void;
}

export const PremiumModal: React.FC<PremiumModalProps> = ({
  isOpen,
  onClose,
  currentUser,
  appSettings,
  onUpdateProfile,
  onUpdateSettings,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-xl flex items-center justify-center p-2 sm:p-4 overflow-y-auto animate-in fade-in duration-150">
      <div className="relative w-full max-w-5xl bg-[#080d16] border border-slate-800 rounded-3xl overflow-hidden shadow-2xl my-auto max-h-[95vh] flex flex-col">
        {/* Sticky close bar */}
        <div className="flex items-center justify-between px-6 py-3.5 bg-[#0e1422] border-b border-slate-800 shrink-0">
          <div className="flex items-center gap-2">
            <span className="text-base font-black text-white">وتين Premium 👑</span>
            <span className="text-xs text-amber-400 font-bold px-2 py-0.5 rounded-full bg-amber-500/10 border border-amber-500/30">
              المزايا الحصرية
            </span>
          </div>

          <button
            onClick={onClose}
            className="p-1.5 rounded-xl bg-[#141b27] hover:bg-slate-800 text-slate-400 hover:text-white transition"
            aria-label="إغلاق النافذة"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-2 sm:p-4">
          <PremiumView
            currentUser={currentUser}
            appSettings={appSettings}
            onUpdateProfile={onUpdateProfile}
            onUpdateSettings={onUpdateSettings}
            onCloseModal={onClose}
          />
        </div>
      </div>
    </div>
  );
};
